export const dictionary = {
  PAGE_TITLE: {
    ES: "Compartir tu tienda",
    EN: "Share store",
  },
  LINK: {
    ES: "Link de tu tienda",
    EN: "Store link",
  },
  LINK_BODY: {
    ES: "Compartir el link de tu tienda en tus redes sociales te ayudará a recibir más pedidos y potenciar tus ventas.",
    EN: "Sharing the link of your store on your social networks will help you receive more orders and boost your sales channel.",
  },
  SHARE: {
    ES: "Compartir",
    EN: "Share",
  },
  SHARE_BODY: {
    ES: "Envia el link de tu tienda a tus contactos para promocionar tu sitio y conseguir más ventas.",
    EN: "Send your store link to your contacts to promote your site and get more sales.",
  },
  SHARE_INSTAGRAM: {
    ES: "Agrega tu link a tu biografía de Instagram",
    EN: "Add your store link to your Instagram bio",
  },
  SHARE_INSTAGRAM_BODY: {
    ES: "Comparte el link de tu tienda en el Instagram de tu comercio para que tus seguidores puedan visitarlo.",
    EN: "Share your store link on your businesses Instagram so that your followers can visit it.",
  },
  STEP0: {
    ES: "Copia el link de tu tienda Simple.",
    EN: "Copy your store link.",
  },
  STEP1: {
    ES: "Ve a tu perfil de Instagram.",
    EN: "Go to your Instagram profile.",
  },
  STEP2: {
    ES: `Toca el botón Editar perfil.`,
    EN: "Tap Edit Profile button.",
  },
  STEP3: {
    ES: `Ve a enlaces y haz click en "Añadir enlace externo".`,
    EN: `Go to links and click on "Add external link".`,
  },
  STEP4: {
    ES: "Guarda los cambios.",
    EN: "Save the changes.",
  },
  POST: {
    ES: "Publicaciones",
    EN: "Post",
  },
  FOLLOWERS: {
    ES: "Seguidores",
    EN: "Followers",
  },
  FOLLOWING: {
    ES: "Siguiendo",
    EN: "Following",
  },
  EDIT_PROFILE: {
    ES: "Editar perfil",
    EN: "Edit profile",
  },
} as const;
